/** @format */

import { EnumSurveyAnswerStatus } from "../../../Common/Enums/EnumsTypes";
import { PercentagePropsTypes } from "../PercentagePropsTypes";
import "../SCSS/stylesMobile.css";

function PercentageMobileView({
  isPreview,
  questionId,
  surveyAnswers,
  handleChangeInputNumber,
  surveyAnswersInfo,
}: PercentagePropsTypes) {
  return (
    <div className="mobile-supplier-view-percentage-cover">
      <div className="mobile-supplier-view-percentage-lower-limit-cover">
        <input
          disabled={
            isPreview ||
            surveyAnswersInfo?.surveyStatus ===
              EnumSurveyAnswerStatus?.COMPLETED
          }
          type="number"
          className="limits"
          placeholder="Please enter percentage"
          onChange={(e) =>
            surveyAnswersInfo?.surveyStatus !==
              EnumSurveyAnswerStatus?.COMPLETED &&
            handleChangeInputNumber!(questionId, e)
          }
          value={surveyAnswers?.[questionId]?.val ?? ""}
        />
        {surveyAnswersInfo.surveyInfo.questionsInfo.questionObj?.[questionId]
          ?.emissionFactor?.enabled && (
          <div className="mobile-supplier-view-percentage-emission-factor">{`emission factor is ${surveyAnswersInfo?.surveyInfo?.questionsInfo?.questionObj?.[questionId]?.emissionFactor?.value}`}</div>
        )}
      </div>
    </div>
  );
}

export default PercentageMobileView;
